import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VeeValidate from 'vee-validate';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
Vue.use(VeeValidate);
Vue.filter("lowerCase", function(value) {
  if (value)
    return value.toLowerCase();
});
Vue.config.productionTip = false;
//azure insights
try {
  const appInsights = new ApplicationInsights({ config: {
    connectionString: process.env.VUE_APP_AZURE_INSIGHTS
    /* ...Other Configuration Options... */
  } });
  appInsights.loadAppInsights();
  appInsights.trackPageView();
}catch(ex){
//catch
}
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
